import Vue from 'vue'

Vue.directive('allow-scroll', {
    bind(el) {
        el._allowScroll = true
    }
})

Vue.mixin({
    mounted() {
        if (this.$options.name === 'v-text-field' || this.$options.name === 'VTextField') {
            const input = this.$el?.querySelector('input')
            if (input) {
                input.addEventListener('wheel', this._preventNumInputScroll, { passive: false })
            }
        }
    },
    beforeDestroy() {
        if (this.$options.name === 'v-text-field' || this.$options.name === 'VTextField') {
            const input = this.$el?.querySelector('input')
            if (input) {
                input.removeEventListener('wheel', this._preventNumInputScroll)
            }
        }
    },
    methods: {
        _preventNumInputScroll() {
            if (this.type === 'number' && !this.$el._allowScroll) {
                //e.preventDefault() //this disabled page scrolling if mouse was over matching element.
                document.activeElement.blur() //this allows the page to scroll regardless of where the mouse is
            }
        }
    }
})